'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSwipe = require('react-swipe');

var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

var _reactTweetEmbed = require('react-tweet-embed');

var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);

var _Element = require('./Element');

var _Element2 = _interopRequireDefault(_Element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swiper = (_temp = _class = function (_React$Component) {
	(0, _inherits3.default)(Swiper, _React$Component);

	function Swiper(props) {
		(0, _classCallCheck3.default)(this, Swiper);

		var _this = (0, _possibleConstructorReturn3.default)(this, (Swiper.__proto__ || (0, _getPrototypeOf2.default)(Swiper)).call(this, props));

		_this.next = _this.next.bind(_this);
		_this.prev = _this.prev.bind(_this);
		return _this;
	}

	(0, _createClass3.default)(Swiper, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.refs.reactSwipe.slide(0, 0);
		}
	}, {
		key: 'next',
		value: function next() {
			this.refs.reactSwipe.next();
		}
	}, {
		key: 'prev',
		value: function prev() {
			this.refs.reactSwipe.prev();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    data = _props.data,
			    mediaId = _props.mediaId;


			return _react2.default.createElement(
				'div',
				{ className: 'swiper', 'data-media-id': mediaId },
				_react2.default.createElement(
					_reactSwipe2.default,
					{ ref: 'reactSwipe', className: 'carousel', swipeOptions: { speed: 600, continuous: true }, 'data-media-id': data.mediaId, key: data.elements.length + "-" + data.mediaId },
					data.elements.map(function (element, i) {
						return _react2.default.createElement(_Element2.default, { key: "element-" + i + "-" + data.mediaId, data: { type: element.type, src: element.src, subtitle: element.subtitle, mediaId: data.mediaId } });
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'carouselNav' },
					_react2.default.createElement(
						'span',
						{ className: 'arrow', onClick: this.prev },
						_react2.default.createElement('i', { className: 'icon-arrowright' })
					),
					_react2.default.createElement(
						'span',
						{ className: 'arrow', onClick: this.next },
						_react2.default.createElement('i', { className: 'icon-arrowright' })
					)
				)
			);
		}
	}]);
	return Swiper;
}(_react2.default.Component), _class.propTypes = {
	data: _react.PropTypes.shape({
		elements: _react.PropTypes.arrayOf(_react.PropTypes.shape({
			type: _react.PropTypes.string,
			src: _react.PropTypes.string,
			subtitle: _react.PropTypes.string
		}))
	}),
	srcThumbnail: _react.PropTypes.string,
	title: _react.PropTypes.string,
	mediaId: _react.PropTypes.number
}, _temp);
exports.default = Swiper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Swiper.js
// module id = 228
// module chunks = 0